// @flow
import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import styled from 'styled-components'
import type { AppStateType } from '../../reducers/appstate'
import { withRouter } from 'next/router'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import AccountManagement from '@components/account/AccountManagement'
import { GoodSansB2, GoodSansH1, GoodSansLink, QueensH1 } from '@components/shared'
import { LinkWithUtms } from '../../actions/navigationActions'
import ManageSocial from '@components/account/ManageSocial'
import type { ProvidersType } from '../../flowTypes'
import { PROVIDERS } from '../../flowTypes'

type PropsType = {
  userId?: string,
  isSubscribed: boolean,
  email?: string,
  providers: ProvidersType[]
}

type DispatchPropsType = {
}

class Account extends React.Component<PropsType & DispatchPropsType> {
  renderEmail (): React.Node {
    const { email, providers } = this.props
    if (!email || !providers.includes(PROVIDERS.email)) {
      return null
    }
    return (<SectionContainer>
      <SubHeader>Email</SubHeader>
      <SubsectionContainer>
        <Body>{email}</Body>
        <LinkWithUtms pathname={'/account/email'}>
          <Link>CHANGE</Link>
        </LinkWithUtms>
      </SubsectionContainer>
    </SectionContainer>)
  }

  renderPassword (): React.Node {
    const { providers } = this.props
    if (!providers.includes(PROVIDERS.email)) {
      return null
    }
    return (<SectionContainer>
      <SubHeader>Password</SubHeader>
      <SubsectionContainer>
        <Body>•••••••••••</Body>
        <LinkWithUtms pathname={'/account/password'}>
          <Link>CHANGE</Link>
        </LinkWithUtms>
      </SubsectionContainer>
    </SectionContainer>)
  }

  renderSocial (): React.Node {
    return (<SectionContainer>
      <SubHeader>Link social and email accounts</SubHeader>
      <SubsectionContainer>
        <Body><ManageSocial onlyShowCurrentProviders={true} /></Body>
        <LinkWithUtms pathname={'/account/social'}>
          <Link>MANAGE</Link>
        </LinkWithUtms>
      </SubsectionContainer>
    </SectionContainer>)
  }

  renderSubscription (): React.Node {
    const { isSubscribed } = this.props
    return (<SectionContainer border={false}>
      <SubHeader>Subscription details</SubHeader>
      <SubsectionContainer>
        <Body>{isSubscribed ? 'Active' : 'Inactive'}</Body>
        <LinkWithUtms pathname={isSubscribed ? '/account/subscription' : '/subscribe'}>
          <Link>{isSubscribed ? 'MANAGE' : 'SUBSCRIBE'}</Link>
        </LinkWithUtms>
      </SubsectionContainer>
    </SectionContainer>)
  }

  render (): React.Node {
    return (
      <AccountManagement title={'Dipsea | Manage Account'} pageDescription={'Dipsea Account Management'}>
        <FlexCol>
          <Header>Account & Settings</Header>
          <SectionsContainer>
            {this.renderEmail()}
            {this.renderPassword()}
            {this.renderSocial()}
            {this.renderSubscription()}
          </SectionsContainer>
        </FlexCol>
      </AccountManagement>
    )
  }
}

const mapStateToProps = (state: AppStateType): PropsType => {
  return {
    userId: state.user?.id,
    email: state.user.email,
    isSubscribed: state.user?.isSubscribed || false,
    providers: [...(state.user.providers || [])]
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Account))

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Header = styled.h1`
  ${QueensH1};
  font-size: 36px;
  color: ${colors.white};
  text-align: center;
  margin-bottom: 18px;

  ${(props: any): string => config(props).media.md`
    font-size: 44px;
    line-height: 53px;
  `}

  ${(props: any): string => config(props).media.lg`
    font-size: 45px;
    line-height: 54px;
  `}

  ${(props: any): string => config(props).media.xl`
    font-size: 45px;
    line-height: 54px;
  `}
`
const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding-bottom: 16px;
  margin-bottom: 16px;
  ${(props: any): string => {
    if (props.border === false) {
      return 'border-bottom: none;'
    }
    return `border-bottom: 1px solid ${colors.white70}`
    }}
`

const SubsectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const SubHeader = styled.p`
  ${GoodSansH1};
  margin-bottom: 10px;
`

const Body = styled.p`
  ${GoodSansB2};
  color: ${colors.white70};
`

const Link = styled.div`
  ${GoodSansLink};
`
